import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import * as userSelectors from 'selectors/user';
import * as actions from 'actions';
import CompoundIDVerification from 'modules/users/components/CompoundIDVerification';
import Errors from 'components/shared/Errors';

const IDVerification = ({ afterVerification, verificationMethods, showBankIDLogin }) => {
  const dispatch = useDispatch();
  const user = useSelector(userSelectors.userData);
  const isLoading = useSelector(userSelectors.isLoading);
  const documents = useSelector(userSelectors.uploadedKyc);
  const updateState = useSelector(userSelectors.updateState);
  const uploading = useSelector(userSelectors.uploading);
  const errors = useSelector(userSelectors.errors);

  const onSubmit = async (values) => {
    const formData = new FormData();

    formData.append('id_first_name', values.id_first_name.trim());
    formData.append('id_last_name', values.id_last_name.trim());
    formData.append('first_name', values.first_name.trim());
    formData.append('validationType', 'IDENTITY_PROOF');
    formData.append('validationFile', values.front);

    if (values.sidesCount > 1) {
      formData.append('validationFile', values.back);
    }
    dispatch(actions.uploadIDProofRequest(formData));
  };

  const fetch = () => {
    if (user.mango_user_id) {
      dispatch(actions.fetchUploadedKYCRequest());
    }
  };

  const onBankIdLogin = () => {
    if (afterVerification) {
      afterVerification();
    }
  };

  React.useEffect(() => {
    if (updateState === 2 && !uploading) {
      if (afterVerification) {
        afterVerification();
      }
    }

    return () => {
      if (!errors) {
        dispatch(actions.updateUserIdle());
      }
    };
  }, [updateState, uploading]);

  React.useEffect(() => {
    if (!isLoading && !uploading) {
      fetch();
    }
  }, []);

  return (
    <>
      <CompoundIDVerification
        isLoading={isLoading || uploading}
        isUploading={uploading}
        documents={documents}
        user={user}
        onKycSubmit={onSubmit}
        onBankIdLogin={onBankIdLogin}
        verificationMethods={verificationMethods}
        showBankIDLogin={showBankIDLogin}
      />
      <Errors errors={errors} />
    </>
  );
};

IDVerification.propTypes = {
  afterVerification: PropTypes.func,
  verificationMethods: PropTypes.arrayOf(PropTypes.oneOf(['BANKID', 'KYC'])),
  showBankIDLogin: PropTypes.bool,
};

IDVerification.defaultProps = {
  verificationMethods: ['BANKID', 'KYC'],
};

export default IDVerification;
